import * as React from 'react';
import Box from '@mui/material/Box';
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import { Tooltip, Typography } from '@mui/material';
import { ISnackbarContextType } from '../../../shared/models';
import { SnackbarEnum } from '../../../shared/enum';
import ConfirmationModal from '../rateFee/components/confirmation.modal';
import { useSnackbar } from '../../../shared/components/snackbar/Snackbar';
import { RateFeeContext } from '../../../shared/context/rateFeeContext';
import { LogsUtility } from '../../../shared/utilities/logs.utility';
import { IUserActivityLogs } from '../../../shared/models/logs.model';
import { ActivityLogsContext } from '../../../shared/context/logsContext';

const rateData = [
    // for P&I
    // For variable interest rate
    {
        uniqueWithoutProduct: "60 Owner occupied P&I Variable",
        propertyUsage: "Owner occupied",
        repaymentType: "P&I",
        interestType: "Variable",
        lvrRange: 60,
        basicInterestRate: 6.14,
        basicComparisonRate: 6.16,
        offsetInterestRate: 6.14,
        offsetComparisonRate: 6.39,
        increaseDecrease: 0
    },
    {
        uniqueWithoutProduct: "70 Owner occupied P&I Variable",
        propertyUsage: "Owner occupied",
        repaymentType: "P&I",
        interestType: "Variable",
        lvrRange: 70,
        basicInterestRate: 6.14,
        basicComparisonRate: 6.16,
        offsetInterestRate: 6.14,
        offsetComparisonRate: 6.39,
        increaseDecrease: 0
    },
    {
        uniqueWithoutProduct: "80 Owner occupied P&I Variable",
        propertyUsage: "Owner occupied",
        repaymentType: "P&I",
        interestType: "Variable",
        lvrRange: 80,
        basicInterestRate: 6.19,
        basicComparisonRate: 6.21,
        offsetInterestRate: 6.19,
        offsetComparisonRate: 6.44,
        increaseDecrease: 0
    },
    {
        uniqueWithoutProduct: "90 Owner occupied P&I Variable",
        propertyUsage: "Owner occupied",
        repaymentType: "P&I",
        interestType: "Variable",
        lvrRange: 90,
        basicInterestRate: 6.39,
        basicComparisonRate: 6.41,
        offsetInterestRate: 6.39,
        offsetComparisonRate: 6.64,
        increaseDecrease: 0
    },
    {
        uniqueWithoutProduct: "95 Owner occupied P&I Variable",
        propertyUsage: "Owner occupied",
        repaymentType: "P&I",
        interestType: "Variable",
        lvrRange: 95,
        basicInterestRate: 7.19,
        basicComparisonRate: 7.22,
        offsetInterestRate: 7.19,
        offsetComparisonRate: 7.44,
        increaseDecrease: 0
    },
    // For 1 year fixed interest rate
    {
        uniqueWithoutProduct: "70 Owner occupied P&I 1 Year fixed",
        propertyUsage: "Owner occupied",
        repaymentType: "P&I",
        interestType: "1 Year fixed",
        lvrRange: 70,
        basicInterestRate: 5.69,
        basicComparisonRate: 6.12,
        offsetInterestRate: 5.69,
        offsetComparisonRate: 6.34,
        increaseDecrease: 0
    },
    {
        uniqueWithoutProduct: "80 Owner occupied P&I 1 Year fixed",
        propertyUsage: "Owner occupied",
        repaymentType: "P&I",
        interestType: "1 Year fixed",
        lvrRange: 80,
        basicInterestRate: 5.79,
        basicComparisonRate: 6.17,
        offsetInterestRate: 5.79,
        offsetComparisonRate: 6.40,
        increaseDecrease: 0
    },
    {
        uniqueWithoutProduct: "90 Owner occupied P&I 1 Year fixed",
        propertyUsage: "Owner occupied",
        repaymentType: "P&I",
        interestType: "1 Year fixed",
        lvrRange: 95,
        basicInterestRate: 6.05,
        basicComparisonRate: 7.09,
        offsetInterestRate: 6.05,
        offsetComparisonRate: 7.31,
        increaseDecrease: 0
    },
    // For 2 year fixed interest rate
    {
        uniqueWithoutProduct: "70 Owner occupied P&I 2 Year fixed",
        propertyUsage: "Owner occupied",
        repaymentType: "P&I",
        interestType: "2 Year fixed",
        lvrRange: 70,
        basicInterestRate: 5.55,
        basicComparisonRate: 6.05,
        offsetInterestRate: 5.55,
        offsetComparisonRate: 6.28,
        increaseDecrease: 0
    },
    {
        uniqueWithoutProduct: "80 Owner occupied P&I 2 Year fixed",
        propertyUsage: "Owner occupied",
        repaymentType: "P&I",
        interestType: "2 Year fixed",
        lvrRange: 80,
        basicInterestRate: 5.65,
        basicComparisonRate: 6.11,
        offsetInterestRate: 5.65,
        offsetComparisonRate: 6.33,
        increaseDecrease: 0
    },
    {
        uniqueWithoutProduct: "95 Owner occupied P&I 2 Year fixed",
        propertyUsage: "Owner occupied",
        repaymentType: "P&I",
        interestType: "2 Year fixed",
        lvrRange: 95,
        basicInterestRate: 6.15,
        basicComparisonRate: 7.00,
        offsetInterestRate: 6.15,
        offsetComparisonRate: 7.22,
        increaseDecrease: 0
    },
    // For 3 year fixed interest rate
    // {
    //     propertyUsage: "Owner occupied",
    //     repaymentType: "P&I",
    //     interestType: "3 Year fixed",
    //     lvrRange: 70,
    //     basicInterestRate: 5.55,
    //     basicComparisonRate: 6.00,
    //     offsetInterestRate: 5.55,
    //     offsetComparisonRate: 6.22,
    //     increaseDecrease: 0
    // },
    // {
    //     propertyUsage: "Owner occupied",
    //     repaymentType: "P&I",
    //     interestType: "3 Year fixed",
    //     lvrRange: 80,
    //     basicInterestRate: 5.65,
    //     basicComparisonRate: 6.06,
    //     offsetInterestRate: 5.65,
    //     offsetComparisonRate: 6.29,
    //     increaseDecrease: 0
    // },
    // {
    //     propertyUsage: "Owner occupied",
    //     repaymentType: "P&I",
    //     interestType: "3 Year fixed",
    //     lvrRange: 95,
    //     basicInterestRate: 6.15,
    //     basicComparisonRate: 6.91,
    //     offsetInterestRate: 6.15,
    //     offsetComparisonRate: 7.13,
    //     increaseDecrease: 0
    // },
    // // For 4 year fixed interest rate
    // {
    //     propertyUsage: "Owner occupied",
    //     repaymentType: "P&I",
    //     interestType: "4 Year fixed",
    //     lvrRange: 70,
    //     basicInterestRate: 5.69,
    //     basicComparisonRate: 6.00,
    //     offsetInterestRate: 5.69,
    //     offsetComparisonRate: 6.23,
    //     increaseDecrease: 0
    // },
    // {
    //     propertyUsage: "Owner occupied",
    //     repaymentType: "P&I",
    //     interestType: "4 Year fixed",
    //     lvrRange: 80,
    //     basicInterestRate: 5.79,
    //     basicComparisonRate: 6.07,
    //     offsetInterestRate: 5.79,
    //     offsetComparisonRate: 6.30,
    //     increaseDecrease: 0
    // },
    // {
    //     propertyUsage: "Owner occupied",
    //     repaymentType: "P&I",
    //     interestType: "4 Year fixed",
    //     lvrRange: 95,
    //     basicInterestRate: 6.29,
    //     basicComparisonRate: 6.88,
    //     offsetInterestRate: 6.29,
    //     offsetComparisonRate: 7.10,
    //     increaseDecrease: 0
    // },
    // // For 5 year fixed interest rate
    // {
    //     propertyUsage: "Owner occupied",
    //     repaymentType: "P&I",
    //     interestType: "5 Year fixed",
    //     lvrRange: 70,
    //     basicInterestRate: 5.69,
    //     basicComparisonRate: 5.97,
    //     offsetInterestRate: 5.69,
    //     offsetComparisonRate: 6.20,
    //     increaseDecrease: 0
    // },
    // {
    //     propertyUsage: "Owner occupied",
    //     repaymentType: "P&I",
    //     interestType: "5 Year fixed",
    //     lvrRange: 80,
    //     basicInterestRate: 5.79,
    //     basicComparisonRate: 6.04,
    //     offsetInterestRate: 5.79,
    //     offsetComparisonRate: 6.27,
    //     increaseDecrease: 0
    // },
    // {
    //     propertyUsage: "Owner occupied",
    //     repaymentType: "P&I",
    //     interestType: "5 Year fixed",
    //     lvrRange: 95,
    //     basicInterestRate: 6.29,
    //     basicComparisonRate: 6.81,
    //     offsetInterestRate: 6.29,
    //     offsetComparisonRate: 7.03,
    //     increaseDecrease: 0
    // },
    // // for IO
    // // For variable interest rate
    // {
    //     propertyUsage: "Owner occupied",
    //     repaymentType: "IO",
    //     interestType: "Variable",
    //     lvrRange: 60,
    //     basicInterestRate: 6.50,
    //     basicComparisonRate: 6.53,
    //     offsetInterestRate: 6.50,
    //     offsetComparisonRate: 6.75,
    //     increaseDecrease: 0
    // },
    // {
    //     propertyUsage: "Owner occupied",
    //     repaymentType: "IO",
    //     interestType: "Variable",
    //     lvrRange: 70,
    //     basicInterestRate: 6.54,
    //     basicComparisonRate: 6.57,
    //     offsetInterestRate: 6.54,
    //     offsetComparisonRate: 6.79,
    //     increaseDecrease: 0
    // },
    // {
    //     propertyUsage: "Owner occupied",
    //     repaymentType: "IO",
    //     interestType: "Variable",
    //     lvrRange: 80,
    //     basicInterestRate: 6.65,
    //     basicComparisonRate: 6.68,
    //     offsetInterestRate: 6.65,
    //     offsetComparisonRate: 6.90,
    //     increaseDecrease: 0
    // },
    // // For 1 year fixed interest rate
    // {
    //     propertyUsage: "Owner occupied",
    //     repaymentType: "IO",
    //     interestType: "1 Year fixed",
    //     lvrRange: 70,
    //     basicInterestRate: 5.95,
    //     basicComparisonRate: 6.50,
    //     offsetInterestRate: 5.95,
    //     offsetComparisonRate: 6.73,
    //     increaseDecrease: 0
    // },
    // {
    //     propertyUsage: "Owner occupied",
    //     repaymentType: "IO",
    //     interestType: "1 Year fixed",
    //     lvrRange: 80,
    //     basicInterestRate: 6.05,
    //     basicComparisonRate: 6.61,
    //     offsetInterestRate: 6.05,
    //     offsetComparisonRate: 6.83,
    //     increaseDecrease: 0
    // },
    // // For 2 year fixed interest rate
    // {
    //     propertyUsage: "Owner occupied",
    //     repaymentType: "IO",
    //     interestType: "2 Year fixed",
    //     lvrRange: 70,
    //     basicInterestRate: 5.85,
    //     basicComparisonRate: 6.43,
    //     offsetInterestRate: 5.85,
    //     offsetComparisonRate: 6.65,
    //     increaseDecrease: 0
    // },
    // {
    //     propertyUsage: "Owner occupied",
    //     repaymentType: "IO",
    //     interestType: "2 Year fixed",
    //     lvrRange: 80,
    //     basicInterestRate: 5.95,
    //     basicComparisonRate: 6.54,
    //     offsetInterestRate: 5.95,
    //     offsetComparisonRate: 6.76,
    //     increaseDecrease: 0
    // },
    // // For 3 year fixed interest rate
    // {
    //     propertyUsage: "Owner occupied",
    //     repaymentType: "IO",
    //     interestType: "3 Year fixed",
    //     lvrRange: 70,
    //     basicInterestRate: 5.85,
    //     basicComparisonRate: 6.37,
    //     offsetInterestRate: 5.85,
    //     offsetComparisonRate: 6.59,
    //     increaseDecrease: 0
    // },
    // {
    //     propertyUsage: "Owner occupied",
    //     repaymentType: "IO",
    //     interestType: "3 Year fixed",
    //     lvrRange: 80,
    //     basicInterestRate: 5.95,
    //     basicComparisonRate: 6.47,
    //     offsetInterestRate: 5.95,
    //     offsetComparisonRate: 6.70,
    //     increaseDecrease: 0
    // },
    // // For 4 year fixed interest rate
    // {
    //     propertyUsage: "Owner occupied",
    //     repaymentType: "IO",
    //     interestType: "4 Year fixed",
    //     lvrRange: 70,
    //     basicInterestRate: 5.99,
    //     basicComparisonRate: 6.36,
    //     offsetInterestRate: 5.99,
    //     offsetComparisonRate: 6.59,
    //     increaseDecrease: 0
    // },
    // {
    //     propertyUsage: "Owner occupied",
    //     repaymentType: "IO",
    //     interestType: "4 Year fixed",
    //     lvrRange: 80,
    //     basicInterestRate: 6.09,
    //     basicComparisonRate: 6.47,
    //     offsetInterestRate: 6.09,
    //     offsetComparisonRate: 6.69,
    //     increaseDecrease: 0
    // },
    // // For 5 year fixed interest rate
    // {
    //     propertyUsage: "Owner occupied",
    //     repaymentType: "IO",
    //     interestType: "5 Year fixed",
    //     lvrRange: 70,
    //     basicInterestRate: 5.99,
    //     basicComparisonRate: 6.32,
    //     offsetInterestRate: 5.99,
    //     offsetComparisonRate: 6.55,
    //     increaseDecrease: 0
    // },
    // {
    //     propertyUsage: "Owner occupied",
    //     repaymentType: "IO",
    //     interestType: "5 Year fixed",
    //     lvrRange: 80,
    //     basicInterestRate: 6.09,
    //     basicComparisonRate: 6.43,
    //     offsetInterestRate: 6.09,
    //     offsetComparisonRate: 6.65,
    //     increaseDecrease: 0
    // },
]

const columns: GridColDef<(any)[number]>[] = [
    {
        field: 'id',
        headerName: 'Index',
        width: 60,
        headerAlign: 'center',
        align: 'center',
        filterable: true,
        sortable: true,
        hideable: false
    },
    {
        field: 'uniqueWithoutProduct',
        headerName: 'Unique without product',
        width: 220,
        headerAlign: 'center',
        align: 'center',
        filterable: true,
        sortable: true,
        hideable: false
    },
    {
        field: 'propertyUsage',
        headerName: 'Property usage',
        width: 180,
        headerAlign: 'center',
        align: 'center',
        editable: false,
    },
    {
        field: 'repaymentType',
        headerName: 'Repayment type',
        width: 180,
        headerAlign: 'center',
        align: 'center',
        editable: false,
    },
    {
        field: 'interestType',
        headerName: 'Interest type',
        width: 180,
        headerAlign: 'center',
        align: 'center',
        editable: false,
    },
    {
        field: 'lvrRange',
        headerName: 'LVR range',
        width: 180,
        headerAlign: 'center',
        align: 'center',
        editable: false,
        valueFormatter: (params: any) => `≤ ${Number(params ?? 0)}%`,
    },
    {
        field: 'basicInterestRate',
        headerName: 'Basic interest rate',
        width: 180,
        headerAlign: 'center',
        align: 'center',
        editable: false,
        type: 'number',
        valueFormatter: (params: any) => `${(Number(params ?? 0))?.toFixed(2)}%`,
        // valueParser: (params: any) => {
        //     return params > 100 ? 100 : params
        // },
    },
    {
        field: 'basicComparisonRate',
        headerName: 'Basic comparison rate',
        width: 180,
        headerAlign: 'center',
        align: 'center',
        editable: true,
        type: 'number',
        valueFormatter: (params: any) => `${Number(params ?? 0)?.toFixed(2)}%`
    },
    {
        field: 'offsetInterestRate',
        headerName: 'Offset interest rate',
        width: 180,
        headerAlign: 'center',
        align: 'center',
        editable: true,
        type: 'number',
        valueFormatter: (params: any) => `${Number(params ?? 0)?.toFixed(2)}%`
    },
    {
        field: 'offsetComparisonRate',
        headerName: 'Offset comparison rate',
        width: 180,
        headerAlign: 'center',
        align: 'center',
        editable: true,
        type: 'number',
        valueFormatter: (params: any) => `${Number(params ?? 0)?.toFixed(2)}%`
    },
    {
        field: 'increaseDecrease',
        headerName: 'Increase/Decrease',
        width: 180,
        headerAlign: 'center',
        align: 'center',
        editable: true,
        type: 'number',
        renderHeader: (params) => (
            <Tooltip title="Modify basic interest rate" arrow placement='top'>
                <Box component={'span'} fontWeight={600}>{params.colDef.headerName}</Box>
            </Tooltip>
        ),
        valueFormatter: (params: any) => `${Number(params ?? 0)?.toFixed(2)}%`
    },
];

const findChangedValue = (newRow: any, oldRow: any) => {
    for (let key in newRow) {
        if (newRow[key] !== oldRow[key]) {
            return key; // Return the changed field name (or the changed value if needed)
        }
    }
    return null;
}

const handlePropertyName = (name: string) => {
    return name
        .replace(/([a-z0-9])([A-Z])/g, '$1 $2') // Add space before uppercase letters
        .toLowerCase() // Convert all letters to lowercase
        .replace(/^./, (match) => match.toUpperCase()); // Capitalize the first letter
}

function MacquarieRates() {
    const logs = React.useContext(ActivityLogsContext as any);
    const rateFee = React.useContext(RateFeeContext as any);
    if (!JSON.parse(sessionStorage.getItem('rates') as string)) {
        sessionStorage.setItem('rates', JSON.stringify(rateData));
    }
    if (!JSON.parse(sessionStorage.getItem('rateFee') as string)) {
        sessionStorage.setItem('rateFee', JSON.stringify(rateFee));
    }
    const data = JSON.parse(sessionStorage.getItem('rates') as string) as any[];
    // const dispatchInterestRate = React.useContext(RateFeeDispatchContext)
    const { showSnackbar } = useSnackbar() as ISnackbarContextType;
    const [isConfirmationModel, setConfirmationModal] = React.useState(false);
    const [selectedRowData, setSelectRowData] = React.useState({ newRow: null, oldRow: null });
    const [rows, setRows] = React.useState(data.map((row, index) => { return { ...row, id: index + 1 } }));
    const handleCloseConfirmationModal = (isClose: boolean) => {
        let index = selectedRowData.newRow ? rows.findIndex(item => item.id === (selectedRowData.newRow as any)?.id) : -1;
        if (index !== -1 && isClose) {
            const basicInterestRateBaseValue = rateData?.find((el) =>
            (el?.propertyUsage?.toString() === (selectedRowData.newRow as any)?.propertyUsage?.toString() &&
                el?.lvrRange?.toString() === (selectedRowData.newRow as any)?.lvrRange?.toString() &&
                el?.repaymentType?.toString() === (selectedRowData.newRow as any)?.repaymentType?.toString() &&
                el?.interestType?.toString() === (selectedRowData.newRow as any)?.interestType?.toString())
            );
            const updatedBasicInterest = basicInterestRateBaseValue && Number(basicInterestRateBaseValue.basicInterestRate ?? 0) + Number((selectedRowData.newRow as any)?.increaseDecrease ?? 0);

            // (selectedRowData.newRow as any) = {...(selectedRowData.newRow as any), basicInterestRate: Number(updatedBasicInterest)?.toFixed(2)}


            let updatedRow = [...rows];
            updatedRow[index] = { ...(selectedRowData.newRow as any), basicInterestRate: Number(updatedBasicInterest ?? 0)?.toFixed(2) };

            let updatedProperty = findChangedValue(selectedRowData.newRow, selectedRowData.oldRow);
            // console.log(`User has updated the ${updatedProperty} form ${((selectedRowData.oldRow as any)[updatedProperty as keyof {}]) ?? 0} to ${((selectedRowData.newRow as any)[updatedProperty as keyof {}]) ?? 0}`)

            sessionStorage.setItem('rates', JSON.stringify(updatedRow));
            setRows(updatedRow);

            let currentLog = new LogsUtility().updateUserLogs(
                { name: '', userEmail: '' },
                {},
                'event' as any,
                'id',
                'customerID',
                { description: (updatedProperty === 'basicInterestRate' || updatedProperty === 'increaseDecrease') ? `Mukesh salaria has updated the Basic interest rate from ${Number((selectedRowData.oldRow as any)?.basicInterestRate ?? 0)?.toFixed(2) ?? 0} to ${Number(updatedBasicInterest ?? 0)?.toFixed(2) ?? 0} where scenario is <b>${(selectedRowData.newRow as any).uniqueWithoutProduct}</b>` : `Mukesh salaria has updated the ${handlePropertyName(updatedProperty as string)} from ${Number((selectedRowData.oldRow as any)[updatedProperty as keyof {}] ?? 0)?.toFixed(2) ?? 0} to ${Number((selectedRowData.newRow as any)[updatedProperty as keyof {}] ?? 0)?.toFixed(2) ?? 0} where scenario is <b>${(selectedRowData.newRow as any).uniqueWithoutProduct}</b>` }
                // {description: `Mukesh salaria has updated the ${handlePropertyName(updatedProperty as string)} from ${Number((selectedRowData.oldRow as any)[updatedProperty as keyof {}])?.toFixed(2) ?? 0} to ${Number((selectedRowData.newRow as any)[updatedProperty as keyof {}])?.toFixed(2) ?? 0}`}
            )
            const updatedLogs: IUserActivityLogs[] = JSON.parse(sessionStorage.getItem('activityLogs') as string) ?? logs;
            updatedLogs.unshift(currentLog)

            sessionStorage.setItem('activityLogs', JSON.stringify(updatedLogs));

            // console.log((selectedRowData.newRow as any));
            showSnackbar(
                "Record updated successfully",
                SnackbarEnum.Success,
            );

            const oldRates = JSON.parse(sessionStorage.getItem('rateFee') as string) ? JSON.parse(sessionStorage.getItem('rateFee') as string) : rateFee
            // console.log(oldRates);
            // update session storage 
            const updated = oldRates?.map((el: any) =>
                (el?.propertyUsage?.toString() === (updatedRow[index] as any)?.propertyUsage?.toString() &&
                    el?.lvr?.toString() === (updatedRow[index] as any)?.lvrRange?.toString() &&
                    el?.repaymentType?.toString() === (updatedRow[index] as any)?.repaymentType?.toString() &&
                    el?.interestType?.toString() === (updatedRow[index] as any)?.interestType?.toString()) ?
                    { ...el, baseRate: (Number((updatedRow[index] as any)?.basicInterestRate ?? 0) - 0.05)?.toFixed(2), borrowerRate: (+(Number((updatedRow[index] as any)?.basicInterestRate ?? 0) - 0.05 - 0.1)?.toFixed(2)) } : el
            );
            sessionStorage.setItem('rateFee', JSON.stringify(updated))


            // dispatchInterestRate({ type: 'updateRates', state: JSON.parse(sessionStorage.getItem('rateFee') as string) ? JSON.parse(sessionStorage.getItem('rateFee') as string) : rateFee, updatedItem: updatedRow[index] })

        }
        if (!isClose) {
            setRows(rows);
        }
        setConfirmationModal(false);
    };

    const handleProcessRowUpdate = (newRow: any, oldRow: any, isModalClose: boolean = false) => {
        let updatedProperty = findChangedValue(newRow, oldRow);
        setSelectRowData({ newRow, oldRow });
        if (updatedProperty) {
            setConfirmationModal(true);
        }
        return oldRow;
    }

    const handleCellKeyDown = (params: any, event: React.KeyboardEvent<HTMLElement>) => {
        const allowedCharacters = [
            '0',
            '1',
            '2',
            '3',
            '4',
            '5',
            '6',
            '7',
            '8',
            '9',
            'Backspace',
            'Tab',
            'Enter',
            'ArrowLeft',
            'ArrowRight',
            'Delete',
            '.',
            '-'
        ]
        if (!allowedCharacters.includes(event.key)) {
            event.preventDefault();
        }
    };

    return (
        <Box component={'section'} p={3} bgcolor={"#f5f5f5"} height={"100%"}>
            {/* <Box sx={{ width: '100%', bgcolor: "#fff", borderRadius: 2, boxShadow: 2, p: 3 }}> */}
            <Typography variant="h5" color="primary" mb={2} fontWeight={600}>
                Macquarie rates
            </Typography>
            {/* height 636px */}
            <DataGrid
                sx={{
                    borderRadius: 1.5, bgcolor: "#fff", height: "684px",
                    '& .MuiDataGrid-columnHeader': {
                        backgroundColor: '#ebedf3', // Customize with your desired color
                    },
                    '& .MuiDataGrid-cell, & .MuiDataGrid-cell.MuiDataGrid-cell--editing, & .MuiDataGrid-columnHeader': {
                        '&focus, &:focus-within': {
                            outlineOffset: "-2px"
                        }
                    },
                    '& .MuiDataGrid-columnHeaderTitle': {
                        fontWeight: 'bold',
                    },
                    '& input[type=number]': {
                        '&::-webkit-outer-spin-button, &::-webkit-inner-spin-button': {
                            appearance: 'none'
                        },
                        mozAppearance: 'textfield',
                        width: '100%',
                        textAlign: 'center',
                    },
                }}
                showCellVerticalBorder
                rows={rows}
                columns={columns}
                initialState={{
                    pagination: {
                        paginationModel: {
                            pageSize: 10,
                        },
                    },
                }}
                pageSizeOptions={[5, 10, 20, 25, 50]}
                onCellKeyDown={(params: any, event: React.KeyboardEvent<HTMLElement>) => handleCellKeyDown(params, event)}
                processRowUpdate={(newRow, oldRow) => handleProcessRowUpdate(newRow, oldRow)}
            />
            {/* </Box> */}
            <ConfirmationModal open={isConfirmationModel} handleClose={(isClose) => handleCloseConfirmationModal(isClose)} />
        </Box>
    )
}

export default MacquarieRates